export default {
  Name: "",
  Description: null,
  Id: 0,
  IsEnabled: false,
  IsNull: false
};
